module.exports = __webpack_public_path__ + "img/marker-new-address.6250b95f.svg";